<div class="tile-padding-first client-users" id="clientadmin">
  <form [formGroup]="clientForm">

    <div class="flex-search-container" [class.filter-bar]="filtersEnabled">
      <div fxLayout="column" fxLayout.gt-md="row" class="filter-bar__group">
        <div fxLayout.gt-md="column" class="filter-bar__field">
          @if (filtersEnabled) {
            <label class="field__label">Search</label>
          }
          <app-typeahead inputClass="field__control body-content" placeholder="Client name/User name/Email"
            formControlName="searchPhrase" [enabled]="autocompleteEnabled" [source]="clientNames"></app-typeahead>
          </div>
          <ng-container *appFeatureSwitch="filtersKey">
            <div fxLayout.gt-md="column" class="filter-bar__group">
              <app-brand-filter class="filter-bar__field" [(companyIds)]="companyIds"></app-brand-filter>
            </div>
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <label class="field__label">Role</label>
              <select class="field__control" [(ngModel)]="roleCode" [ngModelOptions]="{ standalone: true }" data-filter="role">
                <option value="">Any</option>
                <option value="CLIENT">Admin</option>
                <option value="CUSTODIAN">Custodian</option>
                <option value="CLREPORTS">Reports</option>
              </select>
            </div>
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <label class="field__label">Status</label>
              <select class="field__control" [(ngModel)]="activeFilter" [ngModelOptions]="{ standalone: true }" data-filter="active">
                <option value="">Any</option>
                <option value="true">Active</option>
                <option value="false">Deactivated</option>
              </select>
            </div>
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <label class="field__label">Sign-in</label>
              <select class="field__control" [(ngModel)]="authMethod" [ngModelOptions]="{ standalone: true }" data-filter="auth-method">
                <option value="">Any</option>
                <option value="both">Password and Entra</option>
                <option value="password">Password only</option>
                <option value="entra">Entra only</option>
                <option value="none">Neither</option>
              </select>
            </div>
            <div fxLayout.gt-md="column" class="filter-bar__field filter-bar__field--check">
              <label class="field__checkbox" data-filter="never-signed-in">
                <input type="checkbox" [(ngModel)]="neverSignedIn" [ngModelOptions]="{ standalone: true }" /> Never signed in
              </label>
            </div>
          </ng-container>
          @if (!filtersEnabled) {
            <div fxLayout.gt-md="column">
              <div class="btn-align">
                <button type="button" class="btn btn-primary" name="btnSearch" value="Search"
                (click)="search()">Search</button>
                <button type="button" class="btn btn-primary" name="btnAddUser" value="New User" (click)="addUser()">New
                User</button>
              </div>
            </div>
          }
        </div>
        @if (filtersEnabled) {
          <div class="filter-bar__actions">
            <div class="filter-bar__start">
              <button type="button" class="btn btn-primary" name="btnAddUser" value="New User" (click)="addUser()">New
              User</button>
            </div>
            <div class="filter-bar__buttons">
              <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
              <button type="button" class="btn btn-primary" name="btnSearch" value="Search"
              (click)="search()">Search</button>
            </div>
          </div>
        }
      </div>

      @if (showUserPanel) {
        <div class="tw:mb-6">
          <add-update-user (onDataSaved)="onDataSavedGet($event)" (onClosed)="onClosed($event)">
          </add-update-user>
        </div>
      }

      <label class="tw:text-danger">{{errorMsg}}</label>


      <div class="admin-table-container client-users__list">
        <!-- Wide, a table; narrow (see the @container rules), each user stacks into a block. The wrapper scrolls
             sideways only if something inside is still too wide, so the page itself never does. -->
        <div class="client-users__scroll tw:mb-2">

          <table class="table table-hover client-users__table">
            <thead>
              <tr class="main-user-table-header-row">
                <th scope="col"> First name </th>
                <th scope="col"> Last name </th>
                <th scope="col"> Email </th>
                <th scope="col"> MFA Required </th>
                <th scope="col"> Status </th>
                <th scope="col"> Actions </th>
              </tr>
            </thead>
            <tbody>
              @for (user of clientUsers | paginate: { itemsPerPage: 5, currentPage: paginatorPage }; track user; let i = $index) {
                <tr class="main-user-table-row" [ngClass]="{'custom-striped': i % 2 == 0}">
                  <td class="tw:align-middle client-users__name" data-label="First name"> {{user.firstName}} </td>
                  <td class="tw:align-middle client-users__name" data-label="Last name"> {{user.lastName}} </td>
                  <td class="tw:align-middle client-users__email" data-label="Email"><admin-email [value]="user.emailAddress"></admin-email></td>
                  <td class="tw:align-middle" data-label="MFA Required">
                    <label class="field__checkbox"><input type="checkbox" [checked]="user.mfaRequired" (change)="assignMfaRequired(user, {checked: $event.target.checked})" /> MFA</label>
                  </td>
                  <td class="tw:align-middle" data-label="Status">
                    @if (user.active) {
                      <img src="../../../assets/img/user-enabled.svg" class="user-client-status-img" alt="Active" title="Active" />
                    } @else {
                      <img src="../../../assets/img/user-disabled.svg" class="user-client-status-img" alt="Deactivated" title="Deactivated" />
                    }
                  </td>
                  <td class="tw:align-middle client-users__actions-cell" data-label="Actions">
                    <div class="client-users__actions">
                      <button type="button" class="btn btn-primary" value="Assign Client" (click)="showAddClientRow(i)"
                      title="Click here to assign a client to this user">Assign Client</button>
                      @if (!user.hasPassword) {
                        <button type="button" class="btn btn-primary" name="btnResendActivation" (click)="onResendCode(user)"
                          [disabled]="user.disableResendCode"
                          title="This user has not set a password yet. Email them a new link to set one.">Resend activation</button>
                      }
                    </div>
                  </td>
                </tr>
                <tr class="client-users__detail-row" [ngClass]="{'custom-striped disable-custom-striped': i % 2 == 0, 'disable-row-hover': i % 2 == 1}">
                  <td colspan="6" class="client-users__detail">
                    <client-user-access [userId]="user.userId" [userName]="(user.firstName ?? '') + ' ' + (user.lastName ?? '')" [clients]="user.userClients" [accessVisible]="bookingAccessVisible"
                      (roleChange)="assignClientRole($event.client, { checked: $event.checked }, $event.role)"></client-user-access>
                  </td>
                </tr>
                <tr class="client-users__detail-row" [hidden]="addClientRows[i]"
                  [ngClass]="{'custom-striped disable-custom-striped': i % 2 == 0, 'disable-row-hover': i % 2 == 1}">
                  <td colspan="6" class="client-users__detail no-border">
                    <add-client-row [clientList]="clientList" [existingClients]="user.userClients" [isCustomStripedRow]="i % 2 == 0"
                      (addCancelled)="clientAddCancelled($event, i)" (addClient)="clientAdded($event, user, i)">
                    </add-client-row>
                  </td>
                </tr>
              }

            </tbody>
          </table>
        </div>

        <div class="tw:flex tw:justify-end tw:items-end">
          <pagination-controls
            responsive="true"
            autoHide="true"
            previousLabel="Prev"
            nextLabel="Next"
          (pageChange)="paginatorPage = $event"></pagination-controls>
        </div>

      </div>
      </form>
    </div>
